export default __webpack_public_path__ + "static/media/CapaEditContact.f48a43fc.svg";